/*
创建者 魏强(2018.1.28)
企业品牌 中间广告
*/
<template>
	<div class="module-brand-mid">
        <ad-list  :data="qyMiddleUpAdv.advList" :size="qyMiddleUpAdv.adDetails" ></ad-list>      
        <ad-list  :data="qyMiddleMiddleAdv.advList" :size="qyMiddleMiddleAdv.adDetails" ></ad-list>      
        <ad-list  :data="qyMiddleDownAdv.advList" :size="qyMiddleDownAdv.adDetails" ></ad-list>      
    </div>
</template>
<script>
import adList from './list.vue';
export default {
	props:["qyMiddleUpAdv","qyMiddleMiddleAdv","qyMiddleDownAdv"],
	components:{
		adList
	},
	data(){
		return {
		}
	},
	created(){
	}
}
</script>


// WEBPACK FOOTER //
// index.vue?90fd6632